import { render, staticRenderFns } from "./InvoicePrint.vue?vue&type=template&id=5923057e&"
import script from "./InvoicePrint.vue?vue&type=script&lang=js&"
export * from "./InvoicePrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports